import Swal from 'sweetalert2';

// For interpolating data into a gigSwal `html` option.
export const escapeHtml = (value) => String(value ?? '')
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

export function gigSwal(theme, options) {
  return Swal.fire({
    background: theme.surface,
    color: theme.text,
    confirmButtonColor: theme.primary,
    cancelButtonColor: '#6c757d',
    didOpen: (popup) => {
      popup.style.border = `1px solid ${theme.border}`;
      popup.style.boxShadow = theme.isDark
        ? '0 20px 60px rgba(0,0,0,0.8)'
        : '0 20px 60px rgba(0,0,0,0.15)';
    },
    ...options,
  });
}
